
export default class HomeFilter {
    public selectedStatuses: Array<string>;
    public search: string;
    public bopModel: string;
    public startDate: string;
    public endDate: string;
    public hiddenColumns: Array<string>;
  

    constructor() {
        this.search = ''
        this.bopModel = ''
        this.selectedStatuses = []
        this.startDate = '';
        this.endDate = '';
        this.hiddenColumns = [];
    }
  }
  